/**
 * @ngdoc event
 * @name $gzViewWidthChanged
 * @eventOf gazelle.components.view-container.directive:gzViewContainer
 * @description emitted on `$rootScope` when the view containers width as been impacted
 *   by the app nav or mini-apps opening or closing.
 */
export const VIEW_WIDTH_CHANGED_EVENT = '$gzViewWidthChanged';
export const name = 'gzViewContainer';

/**
 * @ngdoc directive
 * @name gazelle.components.view-container.directive:gzViewContainer
 *
 * @description
 * `<gz-view-container>` is a frame component that is responsible for rendering the application view.
 * It is included as part of `<gz-body-wrap>`.
 */
export default function gzViewContainer() {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var directive = {
    restrict: 'EA',
    transclude: true,
    template: '<ng-transclude></ng-transclude>',
    link: gzViewContainerLink,
  };

  return directive;


  /////////////////
  // private functions

  function gzViewContainerLink(scope, element, attrs) {
    // $log.debug('found a gz-view-container!');
  }

} //gzViewContainer

